var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('div',[_vm._v("各位老板好～")]),_c('div',{staticClass:"notice-content"},[_vm._v(" 随着市场需求不断增长，于2025年1月1日起，黑卡推广通投放底价由1元调至1.1元，特此通知。 ")]),_c('div',{staticClass:"notice-content"},[_vm._v(" 高德黑卡衷心感谢您长期以来对我们广告业务的信任与支持。 ")]),_c('div',{staticClass:"notice-footer"},[_vm._v(" 祝您生意兴隆，财源广进～ ")])])
}]

export { render, staticRenderFns }